import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { Row, Col, Container, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

const TapTapGameSettings = () => {
  const [dailyLimit, setDailyLimit] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  
  const fetchAdvanceInfo = async () => {
    try {
      setLoading(true);
      const { data, error } = await apiCall("GET", "/get-advance-info");
      if (data) {
        console.log("Advance info data:", data);
        // Extract daily limit from tap_tap_game object
        const currentDailyLimit = data?.data?.tap_tap_game?.dailyLimit || 0;
        setDailyLimit(currentDailyLimit);
        console.log("Current daily limit:", currentDailyLimit);
      }
    } catch (e) {
      console.log(e.message);
      toast.error("Failed to fetch advance info");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvanceInfo();
  }, []);

  const handleUpdate = async () => {
    try {
      setLoading(true);
      const body = { dailyLimit: dailyLimit };
      console.log("Update body:", body);
      const {data, error} = await apiCall("POST", `/update-tap-dailyLimit`, body);
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Daily limit updated successfully!");
        fetchAdvanceInfo(); // Refresh the data after update
      }
    } catch (error) {
      console.log("error------", error);
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className="bonanza-settings">
          <div className="input-row1">
            <h2>Tap Tap Game Settings</h2>
            <div className="input-group2">
              <label>Daily Limit:</label>
              <input
                type="number"
                name="dailyLimit"
                placeholder="Enter Daily Limit"
                value={dailyLimit || ""}
                onChange={(e) => setDailyLimit(e.target.value)}
                disabled={loading}
                required
              />
              {loading && <p>Loading...</p>}
            </div>
            <div className="button-container">
              <Button 
                type="submit" 
                variant="primary" 
                onClick={handleUpdate}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Daily Limit"}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default TapTapGameSettings;